import { ChatMessage } from '@/hooks/useWebSocketChat';

// Mock chat messages for testing
export const mockChatHistory: ChatMessage[] = [
  {
    id: 1,
    text: "Hello! I'm your AI coach. I'm here to help you navigate your professional development journey. What would you like to discuss today?",
    fromUser: false,
    timestamp: new Date(Date.now() - 3600000).toISOString(), // 1 hour ago
    userModuleId: 4
  }
];

// Mock AI responses based on user input
export const getMockAIResponse = (userMessage: string): string => {
  const lowerMessage = userMessage.toLowerCase();
  
  if (lowerMessage.includes('career') || lowerMessage.includes('goal')) {
    return "That's great that you're thinking about your career goals! Setting clear objectives is crucial for professional growth. Can you tell me more about where you see yourself in the next 2-3 years? What specific areas would you like to develop?";
  }
  
  if (lowerMessage.includes('challenge') || lowerMessage.includes('problem') || lowerMessage.includes('difficult')) {
    return "I understand you're facing a challenge. It's normal to encounter difficulties in our professional journey. Could you share more details about the specific situation? Understanding the context will help me provide better guidance.";
  }
  
  if (lowerMessage.includes('leadership') || lowerMessage.includes('manage') || lowerMessage.includes('team')) {
    return "Leadership development is an excellent focus area! Effective leadership involves both self-awareness and the ability to inspire others. What aspects of leadership are you most interested in developing? Are you currently in a leadership role, or preparing for one?";
  }
  
  if (lowerMessage.includes('stress') || lowerMessage.includes('overwhelm') || lowerMessage.includes('balance')) {
    return "Work-life balance and stress management are crucial for long-term success. It sounds like you might be feeling some pressure. What specific aspects of your work or life are causing the most stress right now? Let's explore some strategies that might help.";
  }
  
  // Default response
  return "Thank you for sharing that with me. I'd like to understand more about your situation. Could you elaborate on what specific aspects you'd like to explore? Remember, our conversation is a safe space for you to discuss any professional challenges or aspirations you have.";
};